module.exports = __webpack_public_path__ + "static/media/empty.c0778f31.png";